module.exports = __webpack_public_path__ + "static/flags/IZ-134d6a3319af31833066e9cfdfd6fc1e.gif";